import AcquireOSLogo from '../components/AcquireOSLogo';
import '../styles/landing.css';

const features = [
  { label: 'AI Document Reading' },
  { label: 'Instant Deal Scoring' },
  { label: 'Smart Lender Matching' },
  { label: 'Auto LOI Generation' },
  { label: 'Financial Calculator' },
  { label: 'Deal Pipeline Tracker' },
  { label: 'AI Assistant' },
];

const IconUserPlus = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <line x1="19" y1="8" x2="19" y2="14" />
    <line x1="22" y1="11" x2="16" y2="11" />
  </svg>
);

const IconLogin = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
    <polyline points="10 17 15 12 10 7" />
    <line x1="15" y1="12" x2="3" y2="12" />
  </svg>
);

export default function LandingPage({ onSignUp, onSignIn }) {
  return (
    <div className="lp-root">
      <div className="lp-left">
        <div className="lp-left-inner">
          <div className="lp-logo-wrap">
            <AcquireOSLogo size={110} onDark />
            <p className="lp-platform-subtext">Multifamily Deal Intelligence Platform</p>
          </div>

          <div className="lp-feature-section">
            <div className="lp-left-sec-hdr">Integrated Cognitive Modules</div>
            <div className="lp-feature-grid">
              {features.map(f => (
                <div className="lp-feature-item" key={f.label}>
                  <span className="lp-feature-dot" />
                  <span className="lp-feature-label">{f.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lp-stats-section">
            <div className="lp-left-sec-hdr" style={{ marginTop: '8px' }}>Real-time Platform Activity</div>
            <div className="lp-stat-item">
              <h3>LATEST DEAL SCORE</h3>
              <div className="lp-score-card-row">
                <div className="lp-score-display">82/100</div>
                <svg className="lp-score-sparkline" viewBox="0 0 210 64" aria-hidden="true">
                  <path d="M4 55 22 36 38 33 54 25 72 34 90 28 106 20 126 29 146 21 162 22 178 10 206 3" />
                  <circle cx="206" cy="3" r="3.5" />
                </svg>
              </div>
            </div>
            <div className="lp-stat-item">
              <h3>PLATFORM STATS</h3>
              <div className="lp-platform-stats">
                <div className="lp-stat-row">
                  <span>Active Deals</span>
                  <span>247</span>
                </div>
                <div className="lp-stat-row">
                  <span>Total Volume</span>
                  <span>$1.2B</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="lp-right">
        <div className="lp-card">
          <div className="lp-card-logo">
            <AcquireOSLogo size={72} />
          </div>

          <h1 className="lp-card-title">Welcome to AcquireOS AI</h1>
          <p className="lp-card-sub">
            The AI platform built for multifamily investors &mdash; from deal sourcing to close.
          </p>

          <div className="lp-cta-buttons">
            <button className="lp-btn lp-btn--primary" onClick={onSignUp}>
              <span className="lp-btn-icon"><IconUserPlus /></span>
              <span className="lp-btn-text">
                <strong>Sign Up</strong>
                <span className="lp-btn-hint">Create your investor profile</span>
              </span>
            </button>
            <button className="lp-btn lp-btn--outline" onClick={onSignIn}>
              <span className="lp-btn-icon"><IconLogin /></span>
              <span className="lp-btn-text">
                <strong>Sign In</strong>
                <span className="lp-btn-hint">Continue to your dashboard</span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
